export const DEFAULT_THEME = 'DEFAULT_THEME';
export const DARK_THEME = 'DARK_THEME';
